import { $assignment, $date } from './stores';

const title = document.title;

function isChromiumBased(): boolean {
  // Prefer userAgentData brands when available
  // Brands look like: [{brand: 'Chromium', version: '...'}, {brand: 'Google Chrome', ...}]
  const nav: any = navigator;
  try {
    if (nav.userAgentData && Array.isArray(nav.userAgentData.brands)) {
      return nav.userAgentData.brands.some((b: any) =>
        /Chrom|Edge|Microsoft Edge|Brave|Opera|OPR/i.test(b.brand),
      );
    }
  } catch (e) {}

  const ua = navigator.userAgent || '';
  return /Chrome|Chromium|Edg|OPR|Brave/i.test(ua);
}

addEventListener('beforeprint', () => {
  if (!isChromiumBased()) {
    if (document.body.classList.contains('not-chromium')) {
      document.body.classList.add('dismissed-not-chromium');
    }
    document.body.classList.add('not-chromium');
  }
  const date = $date.get();
  const assignment = $assignment.get();
  document.title = `Logbook - ${assignment} (${date})`;
});

addEventListener('afterprint', () => {
  document.title = title;
});
